import axios from 'axios'

const createAppointment = async ({ specialty, name, email, phone, comments }) => {
  const BASE_URL = process.env.GATSBY_STRAPI_URL || 'https://unimel-strapi.herokuapp.com'
  console.log({ process: process.env, BASE_URL })
  if (specialty && name && email && phone && comments) {
    const response = await axios.post(BASE_URL + '/appointments', { specialty, name, email, phone, comments })
    if (response.status === 200)
      return { success: true }
    else
      return { succes: false }
  }
  return
}

export default createAppointment